__turbopack_context__.v({
  "interactiveLayer": "lazyMapView-module-scss-module__en4ZYa__interactiveLayer",
  "placeholder": "lazyMapView-module-scss-module__en4ZYa__placeholder",
  "wrapper": "lazyMapView-module-scss-module__en4ZYa__wrapper",
});
